import { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'app/store/userSlice';
import { shouldUseShipmentCalendar } from './shipmentCalendarUi';

const ShipmentCalendarPage = lazy(() => import('./ShipmentCalendarPage'));

/**
 * Shipment Calendar: admin, staff and sales get the redesigned calendar; anyone else the route admits (warehouse)
 * gets `fallback`, the page it rendered before.
 */
export default function ShipmentCalendarGate({ fallback }) {
  const user = useSelector(selectUser);
  if (!shouldUseShipmentCalendar(user)) {
    return fallback;
  }
  return (
    <Suspense fallback={null}>
      <ShipmentCalendarPage />
    </Suspense>
  );
}
